// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--xKWoa","notification":"_103a151b99--notification--oa5d4"};